<div
  #container
  class="expanded-card"
  [ngClass]="[mode]"
  (mouseleave)="hovered = false; onMouseLeave()"
>
  <ng-container
    [ngTemplateOutlet]="template"
    [ngTemplateOutletContext]="{
      tournament: tournament,
      opened: opened,
      hovered: hovered
    }"
  >
  </ng-container>
</div>
